import {
  Col,
  Row,
  Form,
  Breadcrumb,
  Tabs,
  Select,
  DatePicker,
  message,
  Input,
} from "antd";
import { useState, useEffect, useRef } from "react";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { Link } from "react-router-dom";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { useMutation } from "react-query";
import { PaymentType, createPayment, updatePayment } from "../../api/payments";
import { getSupplierDropdownFiltered } from "../../api/supplier";
import { getCurrencyDropdown } from "../../api/currency";
import { getPaymentModesDropdown } from "../../api/paymentMode";
import { getBillsDropdown } from "../../api/bills";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";
import TextArea from "../UI/InputNumberComponent/TextArea";

function AddEditSupplierBalance() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [t] = useTranslation("common");
  const [key, setKey] = useState("1");
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [Currency, setCurrency] = useState<any>(null);

  const { id } = useParams();
  const [form] = Form.useForm();
  const isEdit = () => {
    return !!id;
  };
  const [areInputsValid, setAreInputsValid] = useState(isEdit());
  const onChange = (key: string) => {
    setKey(key);
  };
  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];
  const [suppliers, setSuppliers] = useState<any>([]);
  const [currencies, setCurrencies] = useState<any>([]);
  const [paymentModes, setPaymentModes] = useState<any>([]);
  const [bills, setBills] = useState<any>([]);
  const [dueDate] = useState<any>(null);
  const sessionId = useRef(localStorage.getItem("sessionId"));

  const { mutateAsync: createPaymentMutation, isLoading: isPaymentCreating } =
    useMutation(
      "createPayment",
      (body: PaymentType) =>
        createPayment({ ...body, sessionId: sessionId.current }),
      {
        onSuccess: (res) => {
          message.success("Saved successfully!");
          navigate("/supplierpayment");
        },
      }
    );
  const { mutateAsync: updatePaymentMutation, isLoading: isPaymentUpdating } =
    useMutation(
      "editPayment",
      (body: PaymentType) =>
        updatePayment(Number(id), { ...body, sessionId: sessionId.current }),
      {
        onSuccess: (res) => {
          message.success("Saved successfully!");
          navigate("/supplierpayment");
        },
      }
    );
  const { mutateAsync: getCurrenciesMutation, isLoading: isCurrenciesLoading } =
    useMutation("getCurrencies", getCurrencyDropdown, {
      onSuccess: (result) => {
        setCurrencies(
          result?.data
            .filter((curr: any) => (isEdit() ? curr : curr.isActive))
            .map((currency: any) => {
              return { value: currency.id, label: currency.name };
            })
        );
      },
    });
  const {
    mutateAsync: getPaymentModeMutation,
    isLoading: isPaymentModeLoading,
  } = useMutation("getPaymentMode", getPaymentModesDropdown, {
    onSuccess: (result) => {
      setPaymentModes(
        result?.data
          .filter((mode: any) => (isEdit() ? mode : mode.isActive))
          .map((mode: { id: number; mode: string }) => {
            return { value: mode.id, label: mode.mode };
          })
      );
    },
  });

  const { mutateAsync: getSuppliersMutation, isLoading: isSuppliersLoading } =
    useMutation("getSuppliers", () => getSupplierDropdownFiltered(true), {
      onSuccess: (result) => {
        setSuppliers(
          result?.data
            .filter((supplier: any) =>
              isEdit() ? supplier : supplier.isActive
            )
            .map((sup: any) => {
              return { value: sup.id, label: sup.name };
            })
        );
      },
    });
  const { mutateAsync: getBillsMutation, isLoading: isBillsLoading } =
    useMutation(
      "getBills",
      (supplierId: number) => getBillsDropdown(supplierId),
      {
        onSuccess: (result) => {
          setBills(
            result?.data
              .filter((bill: any) => bill.isPaid === false)
              .map((bill: any) => {
                return {
                  value: bill.id + " - " + bill.remainingAmountText,
                  label: bill.invoiceNo,
                };
              })
          );
        },
      }
    );
  const mainCurrencyString = localStorage.getItem("mainCurrency");
  const mainCurrency = mainCurrencyString
    ? JSON.parse(mainCurrencyString)
    : null;
  const handleCurrencySelection = (value: any) => {
    setCurrency(value);
    if (value === mainCurrency?.id) {
    }
    setAreInputsValid(isFormValid());
  };

  useEffect(() => {
    if (isEdit()) {
      form.setFieldsValue({
        supplier: state?.pBill?.supp?.id,
        billId: state?.pBill?.id,
        reference: state?.reference,
        paymentModeId: state?.paymentMode?.id,
        currencyId: state?.curr?.id,
        exchangeRate: state?.exchangeRate,
        amount: parseInt(state?.amount),
        notes: state?.notes,
        date: dayjs(new Date(state?.date)),
        dueDate: dayjs(new Date(state?.dueDate)),
      });
      if (mainCurrency?.id === state?.curr?.id) {
        setCurrency(state?.curr?.id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleFinish = () => {
    let formFieldsValue = form.getFieldsValue();
    if (isNaN(formFieldsValue.billId)) {
      const parts = formFieldsValue.billId.split("-")[0].trim();
      formFieldsValue.billId = parseInt(parts);
    }
    const body = {
      ...formFieldsValue,
      isPosted: false,
      postedDate: null,
    };

    const selectedDate = form.getFieldValue("date");
    let selectedDateTime = dayjs(state?.date).format("HH:mm:ss");
    const dateTime = !selectedDate.isSame(dayjs(state?.date), "day");
    if (dateTime) {
      selectedDateTime = dayjs().format("HH:mm:ss");
    }

    const selectedDueDate = form.getFieldValue("dueDate");
    let selecteddueDateTime = dayjs(state?.dueDate).format("HH:mm:ss");
    const dueDate = !selectedDueDate.isSame(dayjs(state?.dueDate), "day");
    if (dueDate) {
      selecteddueDateTime = dayjs().format("HH:mm:ss");
    }

    // Additional code to handle newPayments
    const newPayments = { ...body };
    newPayments.date =
      dayjs(selectedDate).format("MM/DD/YYYY") + " " + selectedDateTime;

    newPayments.dueDate =
      dayjs(selectedDueDate).format("MM/DD/YYYY") + " " + selecteddueDateTime;

    for (const key in newPayments) {
      if (
        typeof newPayments[key] === "string" &&
        newPayments[key].trim() === ""
      ) {
        newPayments[key] = null;
      }
      if (Currency === mainCurrency?.id) {
        newPayments.exchangeRate = 1;
      }
    }
    isEdit()
      ? updatePaymentMutation(newPayments)
      : createPaymentMutation(newPayments);
  };
  useEffect(() => {
    getCurrenciesMutation();
    getPaymentModeMutation();
    getSuppliersMutation();
    isEdit() && getBillsMutation(state?.pBill?.supp?.id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const isFormValid = () => {
    const values = form.getFieldsValue();
    const requiredFields = [
      "supplier",
      "billId",
      "paymentModeId",
      "date",
      "currencyId",
      "amount",
      "dueDate",
    ];

    for (const field of requiredFields) {
      if (!values[field]) {
        return false;
      }
    }

    return true;
  };

  const validateDueDate = (_: any, value: any) => {
    const selectedDate = form.getFieldValue("date");
    if (value && selectedDate && value.isBefore(selectedDate, "day")) {
      return Promise.reject("Due date cannot be before the selected date.");
    }
    return Promise.resolve();
  };

  return (
    <>
      <Row>
        <Col offset={1} span={22} style={{ marginBottom: "10px" }}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <Link to="">{t("purchases")}</Link>,
              },
              {
                title: <Link to="/">{t("payment-list")}</Link>,
              },
              {
                title: (
                  <Link to="">
                    {isEdit() ? `${t("edit-payment")}` : `${t("add-payment")}`}
                  </Link>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("general-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col className="editTitle" offset={1} span={20}>
            {state?.pBill?.supp?.name}
          </Col>
        ) : (
          <Col className="editTitle" offset={1} span={20}>
            {t("add-payment-form")}
          </Col>
        )}
      </Row>
      <Col offset={1} span={22}>
        <Tabs
          data-testid="tab"
          className="ant-tab"
          defaultActiveKey="1"
          activeKey={key}
          items={items}
          onChange={onChange}
        />
      </Col>
      <Col offset={1}>
        <Form
          layout="vertical"
          form={form}
          id="paymentForm"
          onFinish={handleFinish}
        >
          <Row style={{ minHeight: "60vh" }}>
            <Col span={6}>
              <Form.Item
                name="supplier"
                label={`${t("supplier")}`}
                rules={[
                  {
                    required: true,
                    message: "supplier is required",
                  },
                ]}
              >
                <Select
                  placeholder={t("select-supplier")}
                  showSearch={true}
                  optionFilterProp="label"
                  options={suppliers}
                  loading={isSuppliersLoading}
                  onChange={(value) => {
                    getBillsMutation(value);

                    setAreInputsValid(isFormValid());
                  }}
                />
              </Form.Item>

              <Form.Item
                name="billId"
                label={t("bill-number")}
                rules={[
                  {
                    required: true,
                    message: "bill is required",
                  },
                ]}
              >
                <Select
                  showSearch={true}
                  optionFilterProp="label"
                  placeholder={t("select-bill-number")}
                  data-testid="bill"
                  options={bills}
                  loading={isBillsLoading}
                  onChange={() => {
                    setAreInputsValid(isFormValid());
                  }}
                />
              </Form.Item>

              <Form.Item name="reference" label={t("reference-number")}>
                <Input maxLength={50} data-testid="reference" disabled />
              </Form.Item>

              <Form.Item
                name="paymentModeId"
                label={t("payment-mode")}
                rules={[
                  {
                    required: true,
                    message: "payment mode is required",
                  },
                ]}
              >
                <Select
                  showSearch={true}
                  optionFilterProp="label"
                  placeholder={t("select-payment-mode")}
                  data-testid="pay-method"
                  options={paymentModes}
                  loading={isPaymentModeLoading}
                  onChange={() => {
                    setAreInputsValid(isFormValid());
                  }}
                />
              </Form.Item>
            </Col>

            <Col offset={2} span={6}>
              <Form.Item
                name="date"
                label={t("date")}
                rules={[
                  {
                    required: true,
                    message: "date is required",
                  },
                ]}
              >
                <DatePicker
                  data-testid="date"
                  style={{ width: "100%" }}
                  placeholder={`${t("MM/DD/YYYY")}`}
                  format={"MM/DD/YYYY"}
                  onChange={() => {
                    setAreInputsValid(isFormValid());
                  }}
                />
              </Form.Item>

              <Form.Item
                name="currencyId"
                label={t("currency")}
                rules={[
                  {
                    required: true,
                    message: "currency is required",
                  },
                ]}
              >
                <Select
                  placeholder={`${t("select-currency")}`}
                  showSearch={true}
                  optionFilterProp="label"
                  options={currencies}
                  loading={isCurrenciesLoading}
                  onChange={handleCurrencySelection}
                />
              </Form.Item>

              <Form.Item name="exchangeRate" label={t("exchange-rate")}>
                <Input
                  maxLength={15}
                  onChange={() => {
                    setAreInputsValid(isFormValid());
                  }}
                  data-testid="exchange"
                  placeholder={`${t("enter-text")}`}
                  disabled={Currency === mainCurrency?.id}
                />
              </Form.Item>

              <Form.Item
                name="amount"
                label={t("amount")}
                rules={[
                  {
                    required: true,
                    message: "amount is required",
                  },
                ]}
              >
                <InputNumber
                  maxLength={15}
                  data-testid="amount"
                  onChange={() => {
                    setAreInputsValid(isFormValid());
                  }}
                />
              </Form.Item>
            </Col>

            <Col offset={1} span={6}>
              <Form.Item
                name="dueDate"
                label={t("due-date")}
                rules={[
                  {
                    required: true,
                    message: "due date is required",
                  },
                  {
                    validator: validateDueDate,
                  },
                ]}
              >
                <DatePicker
                  value={dueDate}
                  data-testid="duedate"
                  style={{ width: "100%" }}
                  placeholder={`${t("MM/DD/YYYY")}`}
                  format={"MM/DD/YYYY"}
                  onChange={() => {
                    setAreInputsValid(isFormValid());
                  }}
                />
              </Form.Item>

              <Form.Item name="notes" label={`${t("notes")}`}>
                <TextArea maxLength={500} data-testid="description" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Col>

      <Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col>
            <AddEditButton
              disabled={!areInputsValid}
              onClick={() => {
                setIsConfirmOpen(true);
                // handleFinish();
              }}
              data-testid="add-button"
              isLoading={undefined}
            />
          </Col>
        </Col>
      </Row>
      <AddEditModal
        open={isConfirmOpen}
        setOpen={setIsConfirmOpen}
        form="paymentForm"
        name={<span> {state?.pBill?.supp?.name}</span>}
        title="Payment"
        isSaving={isPaymentCreating || isPaymentUpdating}
      />
    </>
  );
}

export default AddEditSupplierBalance;
